// extracted by mini-css-extract-plugin
export default {"linkWrapper":"ImageLinkForm__linkWrapper__HcZsA","actionsWrapper":"ImageLinkForm__actionsWrapper__O3zTd","dropzoneBody":"ImageLinkForm__dropzoneBody__ejBkN"};